;(function (window) {

  let _this

  let slider = function (el, options) {  /**构造函数 */
    let ele = typeof el === "string" ? document.getElementById(el) : el  /**检测传进来的是ID还是DOM元素 */

    if (!(typeof ele === 'object' && ele.nodeType === 1 && typeof ele.nodeName === 'string')) {
      console.error("ele is not Dom")
      return
    }
    
    _this = this

    this.el = ele  /**给全局定义滑动的元素 */
    this.eleWrapper = ele.parentNode  /**定义滑动元素的父级 */

    let elB = this.el.getBoundingClientRect()
    let elWB = this.eleWrapper.getBoundingClientRect()
    
    this.isX = options.isX === true    /**是否开启X轴或Y轴的 */
    this.isY = options.isY === false ? false : true

    if(!this.isX && !this.isY){ /**不开X也不开Y 就返回并嘲讽 */
      console.info("nothing is possiable")
      return
    }

    this.isProInsufficientX = elWB.width - elB.width >= 0  /**判断子的宽度是否大于容器宽度 */
    this.isProInsufficientY = elWB.height - elB.height >= 0 /**判断子的高度是否大于容器高度 */

    this.tranX = 0
    this.tranY = 0   /**当前X,Y位移的值 */

    this.tranXRec = 0
    this.tranYRec = 0   /**记录当前X,Y位移的值 额外的变量 */

    this.minMove = 10  /**最小移动的滑动距离 达到这个距离才能移动 */
    this.overspeed = .35   /**超出范围的滑动速度 */

    this.scale = options.scale === true ?  1/devicePixelRatio : 1  /**viewport缩放值 */
      
    this.springBack = options.springBack === false ? false : true /**是否开启边缘回弹 */
    this.springBackTime = options.springBackTime || .35  /**边缘回弹的时间 */

    this._init(options)  /**初始化相关操作 */
  }

  let data = {}  /**改变值操作DATA 已绑定相关移动函数 */

  Object.defineProperties(data,{
    tran:{ /**当前的位置X Y */
      set(val){
        _this.tranX = val[0]
        _this.tranY = val[1]
        _this.transform({})
      }
    },

    speedX:{ /**设置滑动速度 */
      set(val){
        _this.speedX = val
      }
    },
    
    speedY:{
      set(val){
        _this.speedY = val
      }
    },

    // stickyTranX:{
    //   set(val){

    //   }
    // },

    // stickyTranY:{
    //   set(val){

    //   }
    // }
  })


  slider.prototype = {
    bodyNoScroll(e){ /**给BODY添加的事件 阻止IOS浏览器滑动 */
        if(e.target == this.el){ /**点击当前滑动元素 才阻止 */
          e.preventDefault()
        }
    },

    _start(e){ /**触摸开始函数 */  /**惯性过程中 点击屏幕才更新tranX和tranY */
      if (this.inertialSlidingX) {  /**是否开启惯性 开启了取消定时器*/
        clearInterval(this.inertialSlidingTimerX)
        this.startTimeX = new Date().getTime()
      }

      if (this.inertialSlidingY) {  /**是否开启惯性 开启了取消定时器*/
        clearInterval(this.inertialSlidingTimerY)
        this.startTimeY = new Date().getTime()
      }

      if(this.inertialSlidingX && this.inertialSlidingY){
        clearInterval(this.inertialSlidingTimerAll)
      }

      if(this.inertialSlidingX || this.inertialSlidingY){
        clearTimeout(this.timeout) /**清除一次性定时器 防止回弹 */
        this.getTran()  /**有惯性开启  点击屏幕启动更新位置和暂停惯性功能 */
      }

      // if (this.stickyDom) { /**有粘贴元素也取消动画 */
      //   this.stickyDom.style.transition = ''
      //   this.stickyDom.style.webkitTransition = ''
      // }

      this.el.style.transition = ''  /**取消自动滑动的CSS动画 */
      this.el.style.webkitTransition = ''  /**取消自动滑动的CSS动画 */
      
      if(this.isX){
        this.startX = e.touches[0].clientX
        this.tranXRec = this.tranX   /**记录位置副值 */
      }
      
      if(this.isY){
        this.startY = e.touches[0].clientY   /*起始坐标 */
        this.tranYRec = this.tranY
      }

      this.isMove = false  /**点击时阻止移动 */
    },

    _move(e){  /**滑动函数 */
      if(this.isMove){ 
        let [x,y] = [this.tranX,this.tranY]

        if(this.isX){
             /**先判断X滑动的速度 */
          if (this.isProInsufficientX || this.tranX > this.minX || this.tranX < -this.maxX) {
            data.speedX = this.overspeed  /**任何一轴超出范围就减速 */
          } else {
            data.speedX = this.speedRecX
          }  

          let move = e.touches[0].clientX /**移动时的实时坐标 */
          let sliderDis = this.startX - move 
  
          if(this.isProInsufficientX || this.tranX >= -this.maxX){  /**没拉到底的速度算法 */
  
            x = (this.tranXRec - sliderDis ) * this.speedX /**根据速度决定 */
            this.overX = move  /**记录没到底的坐标  用于到底后 这个坐标减去移动坐标 加上到底坐标 才是实际值 */
  
          }else{
            x = -this.maxX - (this.overX - move) * this.speedX  /**没到底就用这个 常规距离 乘速度 */
          }
          
        }

        if(this.isY){
              /**先判断Y滑动的速度 */
          if (this.isProInsufficientY || this.tranY > this.minY || this.tranY < -this.maxY) {
            data.speedY = this.overspeed  /**任何一轴超出范围就减速 */
          } else {
            data.speedY = this.speedRecY
          } 

          let move = e.touches[0].clientY /**移动时的实时坐标 */
          let sliderDis = this.startY - move

          if(this.isProInsufficientY || this.tranY >= -this.maxY){  /**没拉到底的速度算法   */
              y = (this.tranYRec - sliderDis ) * this.speedY /**根据速度决定 */
              this.overY = move  /**记录没到底的坐标  用于到底后 这个坐标减去移动坐标 加上到底坐标 才是实际值 */

          }else{
              y = -this.maxY - (this.overY - move) * this.speedY /**没到底就用这个 常规距离 乘速度 */
          }
        }

        data.tran = [x,y]

        // if(this.stickyDom){  /**如果有粘贴元素 执行粘贴函数 */
        //   this.stickySlider()
        // }  

      }else{
        let isMoveX = this.isX ? Math.abs((this.startX - e.touches[0].clientX )*this.speedX) > this.minMove : false
        let isMoveY = this.isY ? Math.abs((this.startY - e.touches[0].clientY ) *this.speedY) > this.minMove : false
          /**X或者Y的移动值 */

        if(isMoveX || isMoveY){/**检测滑屏值 大于这个才能滑动 */
          this.isMove = true
          this.startX = e.touches[0].clientX
          this.startY = e.touches[0].clientY
        }
      }

      e.preventDefault()
    },

    _end(){
      let back = false, /**如果為true 则开启回弹 */
          inertX = false,inertY = false  /**如果为true 则开始惯性 */

      if(this.isX){
          if (this.springBack &&  (this.tranX > this.minX || this.tranX < -this.maxX)  ) {
            back = true  /**如果没有上拉加载  放开时划出屏幕 则执行回弹函数 */
    
          } else if (this.inertialSlidingX && this.isMove) {  /**没超出屏幕 并且开启了惯性*/
            this.durTimeX = new Date().getTime() - this.startTimeX 
            if(this.durTimeX <= 300 && this.durTimeX > 50){ /**经历时间小于300才开启 */
              inertX = true
            }
          }

          this.overX = 0
      }

      if(this.isY){
          if (this.springBack &&  (this.tranY > this.minY || this.tranY < -this.maxY)  ) {
    
            if (this.pullUp) { /**开启了上拉加载 */
              if (this.tranY <= -this.maxY - this.pullUpStartDis && !this.isProInsufficientY) {
                let y = -this.maxY - this.pullUpOnDis /**开启上拉加载 就移动到30的距离 */
                let dis = this.tranX + 'px,'+y+'px' /**计算应该回到的距离  上拉加载的30 */
                
                this.transform({time:.3,dis:dis}) /**位移 传时间和距离 */
    
              } else {
                back = true  /**如果放开时划出屏幕 则执行回弹函数 */
              }
    
            } else {
              back = true  /**如果没有上拉加载  放开时划出屏幕 则执行回弹函数 */
            }
      
          } else if (this.inertialSlidingY && this.isMove) {  /**没超出屏幕 并且开启了惯性*/
              this.durTimeY = new Date().getTime() - this.startTimeY 
              if(this.durTimeY <= 300 && this.durTimeY > 50){ /**经历时间小于300才开启 */
                inertY = true
              }
          }

        this.overY  = 0 /**清零滑动数据 */
      }

      if(back){ /**回弹 */
        this.springGoBack()

      }else if(inertX || inertY){  /**或惯性 */
        this.inertialSlideInter(inertX,inertY)
      }
    },

    _inertialMoveX(e){
      this.endX = e.touches[0].clientX - this.startX

      let time = new Date().getTime()
      if(time - this.startTimeX > 300){
        this.startTimeX = time
      }
    },

    _inertialMoveY(e){
      this.endY = e.touches[0].clientY - this.startY

      let time = new Date().getTime()
      if(time - this.startTimeY > 300){
        this.startTimeY = time
      }
    },

    _init(options){  
      this.inertialSlidingX = options.inertialSlidingX === false ? false : this.isX ? true : false/**是否开启X惯性滑动 */
      this.inertialSlidingY = options.inertialSlidingY === false ? false : this.isY ? true : false /**是否开启Y惯性滑动 */

      this.backTop = options.backTop || null  /**指定回到顶部按钮 */
      if (this.backTop) {
        this.backTop = typeof options.backTop === "string" ? document.getElementById(options.backTop) : options.backTop
        let dis = '0px,0px'
        this.backTop.addEventListener('click', () => { 
          if (this.inertialSlidingX) {  /**是否开启惯性 开启了取消定时器*/
            clearInterval(this.inertialSlidingTimerX)
          }
    
          if (this.inertialSlidingY) {  /**是否开启惯性 开启了取消定时器*/
            clearInterval(this.inertialSlidingTimerY)
          }
    
          if(this.inertialSlidingX && this.inertialSlidingY){
            clearInterval(this.inertialSlidingTimerAll)
          }
    
          if(this.inertialSlidingX || this.inertialSlidingY){
            clearTimeout(this.timeout) /**清除一次性定时器 防止回弹 */
          }

          this.transform({ time:.3,dis:dis }) 
        },{passive:false})
      }

      /**添加自定义函数 */
      this.scrollFun = typeof options.scrollFun === 'function' ? options.scrollFun : null /**是否有滚动中的函数 */
      this.startFun = typeof options.startFun === 'function' ? options.startFun : null /**开始函数 */
      this.endFun = typeof options.endFun === 'function' ? options.endFun : null /**结束函数 */
      this.scrollToFun = typeof options.scrollToFun === 'function' ? options.scrollToFun : null  /**惯性滑动中执行的函数 */

      this.stickyDom = options.stickyDom || null /**是否有需要粘贴布局的元素 */
      if(this.stickyDom){
          this.stickyDom = typeof options.stickyDom === "string" ?document.getElementById(options.stickyDom) : options.stickyDom  /**选定粘贴元素 */
          this.stickyDomPos = options.stickyDomPos || 0  /**设置默认粘贴的距离  */
          this.stickyDomPosActionLeft = -this.stickyDom.offsetLeft 
          this.stickyDomPosActionTop =  -this.stickyDom.offsetTop /**触发距离上 算上了指定的偏移量*/
          this.stickyTranX = 0
          this.stickyTranY = 0  /**当前的位移值 */
      }

      if(this.isX){
        this.startX = 0

        this.offsetLEFT = -options.offsetLEFT || 0
        this.offsetRIGHT = options.offsetRIGHT || 0

        this.speedX = options.speedX || 1    /**滑动速度 */
        this.speedRecX = this.speedX  /**记录一个速度复制 用于改变速度后 改回来时 引用这个速度 */

        this.minX = 0 -  this.offsetLEFT
        this.maxX = this.el.getBoundingClientRect().width - this.eleWrapper.getBoundingClientRect().width -  this.offsetRIGHT
        data.tran = [this.minX,0] /**根据偏移  重新计算偏移量 */

        if (this.intertialSlidingX) {
          this.inertialSlidingTimerX = null  /*惯性的定时器 */
        }
      }
      /**检测超出边缘的距离 使用时取负值 */

      if(this.isY){
        this.startY = 0  /**初始化位置 */

        this.offsetTOP = -options.offsetTOP || 0 /**定义4个偏移量  回弹的时候回弹到这个位置 单位PX */
        this.offsetBOTTOM = options.offsetBOTTOM || 0

        this.speedY = options.speedY || 1    /**滑动速度 */
        this.speedRecY = this.speedY

        this.minY = 0 - this.offsetTOP
        this.maxY = this.el.getBoundingClientRect().height - this.eleWrapper.getBoundingClientRect().height - this.offsetBOTTOM 
        data.tran =  [0,this.minY]  /**根据偏移量 初始化偏移位置  有一个不为0  就重设*/

        if (this.intertialSlidingY) {
          this.inertialSlidingTimerY = null  /*惯性的定时器 */
        }
      }

      if((this.isX && this.intertialSlidingX) || (this.isY && this.intertialSlidingY)){ /**任何一轴开启惯性  生成一个一次性定时器 */
        this.timeout = null
      }

      if(this.isX && this.isY && this.intertialSlidingX && this.intertialSlidingY){
        this.this.intertialSlidingAll = null  /**同时的定时器 */
      }

      this.pullUp = options.pullUp === true  /**是否开启上拉加载 */
      if (this.pullUp) {
        this.pullUpStartDis = typeof options.pullUpStartDis === 'number' ? options.pullUpStartDis : 50/this.scale /**触发上拉加载的距离 默认50 */
        this.pullUpOnDis = typeof options.pullUpOnDis === 'number' ? options.pullUpOnDis : 30/this.scale /**加载过程的距离  默认30 */
        // if(this.isX){this.maxX = this.maxX - this.pullUpOnDis}

        if(this.isY){this.maxY = this.maxY - this.pullUpOnDis}
      }
      
      if (this.isX || this.isY) {
        this._addEvent() /**添加事件 */
      }
    },

    _addEvent(){ /**添加事件 */
      this.el.addEventListener('touchstart', ()=>{
        this._start.call(this,event)
      },{passive:false}) /**添加开始 结束函数 */
      
      this.el.addEventListener('touchmove', ()=>{
        this._move.call(this,event)
      },{passive:false})

      this.el.addEventListener("touchend", ()=>{
        this._end.call(this)
      },{passive:false})


      if(this.isX){
        this.overX = 0 /**拉到底后 计算减速滑动用的坐标 */

        if(this.inertialSlidingX){
          this.el.addEventListener('touchmove', ()=>{ /**惯性MOVE函数 */
            this._inertialMoveX.call(this,event)
          },{passive:false})
          
          this.startTimeX = this.durTimeX = 0 /**记录touchstart开始时间和持续时间 */
          this.endX = 0
          this.otranX  = this.isSpeerX = this.lastX = 0 /**做惯性的3个值 */
        }
      }

      if(this.isY){
        this.overY = 0

        if(this.inertialSlidingY){
          this.el.addEventListener('touchmove', ()=>{ /**惯性MOVE函数 */
            this._inertialMoveY.call(this,event)
          },{passive:false})

          this.startTimeY = this.durTimeY = 0
          this.endY = 0
          this.otranY = this.isSpeedY = this.lastY = 0 
        }
      }

      if (this.startFun) { /**如果传进来了自定义开始函数 */
        this.el.addEventListener('touchstart', this.startFun,{passive:false})
      }
      if (this.endFun) { /**如果传进来了自定义开始函数 */
        this.el.addEventListener('touchend', this.endFun,{passive:false})
      }
      if(this.scrollFun) { /**传了 touchemove的自定义函数 */
        this.el.addEventListener('touchmove', this.scrollFun,{passive:false})
      }

      if(navigator.userAgent.indexOf('iPhone') == -1){ /**如果是苹果手机 阻止原生滑动 */
        document.body.addEventListener("touchmove",()=>{
          this.bodyNoScroll.call(this,event)
        },{ passive: false })
      }

      this.isMove = false /**是否可以移动 */

    },

    springGoBack(){  /**超出边界回弹函数 */
      this.el.style.transition = "all " + this.springBackTime + "s ease-in-out"  /**设置回弹动画效果 */
      this.el.style.webkitTransition = "all " + this.springBackTime + "s ease-in-out"  /**设置回弹动画效果 */
      let [x,y] = [this.tranX,this.tranY]
  
      // let over = false /**粘贴是否超边缘 */
      if (this.isX) {
        if (this.isProInsufficientX || this.tranX > this.minX) { /**长度不足或者X位移大于0 */
          x = this.minX     /**加上设定的偏移量 默认0 */
  
        } else if (this.tranX < -this.maxX) { /**长度大于最大距离 */
          x = -this.maxX 
          // over = true
        }
      }
  
      if (this.isY) {
        if (this.isProInsufficientY || this.tranY > this.minY) {
          y = this.minY
  
        } else if (this.tranY < -this.maxY) {
          // if(this.pullUpEvent){
          //   let y = Math.abs(this.tranY) - Math.abs(-this.maxY - this.offsetBOTTOM)
          // }
          y = -this.maxY
          // over = true     
        }
      }
      // if(this.springBack){
      //   this.stickySlider(over)  /**粘贴元素 */
      // }
  
      data.tran = [x,y]
    },

    transform(info){/**基本的移动函数 */
      let ele = info.el || this.el  /**默认传个空对象  就是调用指定的 */
      let dis = info.dis || this.tranX + "px," + this.tranY + 'px'
  
      if(info.time){ /**如果传了时间 就添加时间动画 */
        let ease = this.bezier.default.style   /**缓动 */
        this.el.style.transition = "all " + info.time + "s " + ease  /**设置回弹动画效果 */
        this.el.style.webkitTransition = "all " + info.time + "s " + ease  /**设置回弹动画效果 */
      }
  
      ele.style.transform = "translate(" + dis + ")"
      ele.style.webkitTransform = "translate(" + dis + ")"
    },

    inertialSlideInter(isX,isY){/**惯性滑动函数 */
      isX = isX === true  /**是否开启了X或者Y */
      isY = isY === true
  
      let disX = isX ? this.endX/this.durTimeX/.0015 : 0 ,   /**要移动的距离 */
          disY = isY ? this.endY/this.durTimeY/.0015 : 0 , 
  
          finX = isX ? Math.round(this.tranX + disX) : this.tranX, /* 计算总距离  等于动量开始前的位置加上要移动的距离*/
          finY = isY ? Math.round(this.tranY + disY) : this.tranY,
  
          SpringL = isX ? this.minX + 30/this.scale : 0,/**4个方向回弹值 */
          SpringR = isX ? -this.maxX - 30/this.scale : 0,
          SpringT = isY ? this.minY + 30/this.scale : 0,
          SpringB = isY ? -this.maxY - 30/this.scale : 0
  
  
      if(!this.pullUp){  
        // let time = new Date().getTime()
  
        let tranY = this.tranY /**当前位置记录值 */
        // let maxCount = Math.abs(Math.round(time / 5)) /**每5ms执行一次 除以5  得到执行的最大次数 */
  
        let count = 1 /**定时器执行次数 */
  
        this.inertialSlidingTimerY = setInterval(() => {
          let per = this.bezier.default.fn(count/100)[1] 
  
          let y = per * dis 
  
  
          // let load = (fin - this.tranY)/15
          // load = Math.abs(load) <= .5 ? 0 : Math.ceil(load)
  
          // data.tranY = this.tranY + load
          data.tranY = tranY + y
          
  
          // if(this.stickyDom){
          //   this.stickySlider(true)
          // }
  
          count++
  
          if(this.tranY >= SpringT || this.tranY <= SpringB){
            clearInterval(this.inertialSlidingTimerY)   /**超出边界30px 执行回弹 */
            this.springGoBack()
            return 
          }
          
          if(count >= 101){
            clearInterval(this.inertialSlidingTimerY)
            if( this.tranY < -this.maxY || this.tranY > this.minY){ /**超出边框也回弹 */
              this.springGoBack()
            }
            return 
          }
  
          if(this.scrollToFun){
            this.scrollToFun() /**有自定义的惯性中函数 就执行惯性中函数 */
          }
        },20)
  
      }else{
        let dis = finX + "px," + finY + 'px'
        this.transform({dis:dis,time:3})
  
            /**4个是否超过阈值的比较值 */
        let lx = finX > SpringL,  /**x超出左 */
            rx = finX < SpringR,  /**x超出右 */
            ty = finY > SpringT, /**y超出上 */
            by = finY < SpringB  /**y超出下 */
        
        if( (lx || rx) && !ty && !by){ /**X轴超出 并且y轴不超出 */
            let count = 1
  
            this.inertialSlidingTimerX = setInterval(()=>{
              let x = Number(this.getStyle(this.el,'transform').replace(/[^0-9\-,.]/g,'').split(',')[4]) || 0  
  
              if(x > SpringL || x < SpringR){
                clearInterval(this.inertialSlidingTimerX)
                this.tranX = x
  
                if(isX && !isY){  /**只动X轴情况  */
                  this.springGoBack()  /**直接执行超出回弹 */
  
                }else{
                  let time = (3000 - count)/1000 /**剩余该移动的时间 */
                  let nowX = x >SpringL ? this.minX : -this.maxX  /**X的边缘 */
      
                  let nowDis = nowX + "px," + finY + 'px' /**道边后的时间 */
      
                  this.transform({dis:nowDis,time:time}) /**执行X回弹 Y不回弹 */
                }
                return 
              }
              
              count++
            },1)
  
        }else if(!lx && !rx && (ty || by)){  /**y轴超出，并且x轴不超出 */
            let count = 1
  
            this.inertialSlidingTimerY = setInterval(()=>{
              let y = Number(this.getStyle(this.el,'transform').replace(/[^0-9\-,.]/g,'').split(',')[5]) || 0
  
              if(y > SpringT || y < SpringB){
                clearInterval(this.inertialSlidingTimerY)
                this.tranY = y
  
                if(!isX && isY){  /**只动Y轴情况  */
                  this.springGoBack()  /**直接执行超出回弹 */
  
                }else{
                  let time = (3000 - count)/1000 /**剩余该移动的时间 */
                  let nowY = y > SpringT ? this.minY : -this.maxY  /**Y的边缘 */
      
                  let nowDis = finX + "px," + nowY + 'px' /**道边后的时间 */
      
                  this.transform({dis:nowDis,time:time}) /**执行X回弹 Y不回弹 */
                }
                return 
              }
              
              count++
            },1)
  
        }else if((lx || rx) && (ty || by) ){  /**两轴都超出 */
          let count = 1
  
          this.inertialSlidingTimerAll = setInterval(()=>{
            let x = Number(this.getStyle(this.el,'transform').replace(/[^0-9\-,.]/g,'').split(',')[4]) || 0
            let y = Number(this.getStyle(this.el,'transform').replace(/[^0-9\-,.]/g,'').split(',')[5]) || 0
  
            if(x > SpringL || x < SpringR){
              clearInterval(this.inertialSlidingTimerAll)
              this.tranX = x
  
              let time = (3000 - count)/1000 /**剩余该移动的时间 */
              let nowX = x >SpringL ? this.minX : -this.maxX  /**X的边缘 */
      
              let nowDis = nowX + "px," + finY + 'px' /**道边后的时间 */
  
              this.transform({dis:nowDis,time:time}) /**执行X回弹 Y不回弹 */
  
              this.inertialSlidingTimerAll = setInterval(()=>{
                  let y2 = Number(this.getStyle(this.el,'transform').replace(/[^0-9\-,.]/g,'').split(',')[5]) || 0
  
                  if(y2 > SpringT || y2 < SpringB){
                    this.tranY = y2
                    clearInterval(this.inertialSlidingTimerAll)
                    this.springGoBack()
                    return
                  }
              },1)
  
            }else if(y > SpringT || y < SpringB){
              clearInterval(this.inertialSlidingTimerAll)
              this.tranY = y
  
              let time = (3000 - count)/1000 /**剩余该移动的时间 */
              let nowY = y > SpringT ? this.minY : -this.maxY  /**Y的边缘 */
  
              let nowDis = finX + "px," + nowY + 'px' /**道边后的时间 */
  
              this.transform({dis:nowDis,time:time}) /**执行X回弹 Y不回弹 */
  
              this.inertialSlidingTimerAll = setInterval(()=>{
                  let x2 = Number(this.getStyle(this.el,'transform').replace(/[^0-9\-,.]/g,'').split(',')[4]) || 0
  
                  if(x2 > SpringL || x2 < SpringR){
                    this.tranX = x2 /**回弹的时候 另一轴设置值 */
                    clearInterval(this.inertialSlidingTimerAll)
                    this.springGoBack()
                    return
                  }
              },1)
  
            }
            
            count++
          },1)
  
  
        }else if( (finX > this.minX && !lx) || (finX < -this.maxX && !rx) || 
                  (finY > this.minY && !ty) || (finY < -this.maxY && !by)  ){  /**没超过回弹边界 */
                      /**y超过上面 */                          /**y 超过下面*/
  
            this.tranX = finX
            this.tranY = finY
            this.timeout = setTimeout(()=>{
              this.springGoBack()
            },3000)
  
        }
      }
    },

    getStyle(obj,name){
      return window.getComputedStyle ? getComputedStyle(obj,null)[name] : obj.currentStyle[name]
    },

    getTran(ele){/**获得对应元素的当前位移值  用于点击屏幕 直接移动过去 达到暂停惯性效果*/
      let el = ele || this.el
      let x = Number(this.getStyle(el,'transform').replace(/[^0-9\-,.]/g,'').split(',')[4]) || 0  
      let y = Number(this.getStyle(el,'transform').replace(/[^0-9\-,.]/g,'').split(',')[5]) || 0
  
      data.tran = [x,y]
  
      // if(this.stickyDom){ /**设置粘贴 */
      //   let x2 = Number(getStyle(this.stickyDom,'transform').replace(/[^0-9\-,.]/g,'').split(',')[4]) || 0
      //   let y2 = Number(getStyle(this.stickyDom,'transform').replace(/[^0-9\-,.]/g,'').split(',')[5]) || 0
      //   this.stickyTranX = x2
      //   this.stickyTranY = y2
      // }
    },

    updateInit(){/**刷新函数后 执行此进行部分初始化 */
      let elB = this.el.getBoundingClientRect()
      let elWB = this.eleWrapper.getBoundingClientRect()
  
      if(this.isX){
        this.maxX = elB.width - elWB.width -  this.offsetRIGHT
        this.isProInsufficientX = elWB.width - elB.width >= 0  /**判断子的宽度是否大于容器宽度 */
      }
      /**检测超出边缘的距离 使用时取负值 */
      if(this.isY){
        this.maxY = elB.height - elWB.height - this.offsetBOTTOM 
        this.isProInsufficientY = elWB.height - elB.height >= 0 /**判断子的高度是否大于容器高度 */
      }
  
      if (this.pullUp) {
        if(this.isX){this.maxX = this.maxX - this.pullUpOnDis}
  
        if(this.isY){this.maxY = this.maxY - this.pullUpOnDis}
      }
  
      // if(this.stickyDom){
      //   this.stickyDomPosActionLeft = -this.stickyDom.offsetLeft 
      //   this.stickyDomPosActionTop =  -this.stickyDom.offsetTop /**触发距离上 算上了指定的偏移量*/
      // }
    }

    
  }

 
  slider.prototype.stickySlider = function (over) {
    let [x, y] = [0, 0]
    let isover = over === true  /**是否与边缘回调动画函数同步 */
    if (this.isX && this.tranX < this.stickyDomPosActionLeft) {
      x = this.tranX - this.stickyDomPosActionLeft /**当前位移值小于Offset的负值时就表示应该启动粘贴效果了 */
    }
    if (this.isY && this.tranY < this.stickyDomPosActionTop) {
      y = this.tranY - this.stickyDomPosActionTop
    }
    if (x < 0 || y < 0) {
      if (!isover) {
        this.stickyDom.style.transition = ''
        let dis = -x + 'px,' + -y + 'px'
        this.transform({ el: this.stickyDom, dis: dis }) /**给粘贴元素添加初始事件 */
      } else {
        this.stickyDom.style.transition = "all " + this.springBackTime + "s"  /**设置回弹动画效果 */
        x = this.isX && x < 0 ? -this.tranX + this.stickyDomPosActionLeft : 0
        y = this.isY && y < 0 ? -this.tranY + this.stickyDomPosActionTop : 0  /**判断是否有X或者Y */
        let dis = x + 'px,' + y + 'px'
        this.transform({ el: this.stickyDom, dis: dis }) /**给粘贴元素添加初始事件 */  /**是回弹函数触发就同步动画 */
      }
    } else {
      this.transform({ el: this.stickyDom, dis: '0,0' }) /**给粘贴元素添加初始事件 */
    }
  }

  slider.prototype.bezier ={
      /*B(t) = P0 * (1-t)^3 +     3 * P1 * t * (1-t)^2 +   3 * P2 * t^2 * (1-t) +   P3 * t^3, t ∈ [0,1]  */
      /**p0 固定为[0,0] p3 固定为[1,1] */

    default:{
      style:"cubic-bezier(0.1, 0.85, 0.25, 1)",
      fn(t){
        let add = _this.math.add
        let mul = _this.math.mul
        let pow = _this.math.pow

        let temp = _this.math.sub(1,t) 
        
        let ax = mul( mul(.495,t),  pow(temp,2) )
        let bx =  mul( mul( 1.32, pow(t,2) ),  temp )  
        let cx = pow(t,3)
        let x =  add( add(ax,bx),  cx )

        let ay = mul( mul(2.55,t),  pow(temp,2) )
        let by =  mul( mul( 3, pow(t,2) ),  temp )  
        let cy = pow(t,3)
        let y =  add( add(ay,by),  cy )

        return [x,y]

      }
    },

    linear:{
      style:"cubic-bezier(0,0,1,1)",
      fn(t){
        let add = _this.math.add
        let mul = _this.math.mul
        let pow = _this.math.pow

        let temp = _this.math.sub(1,t) 
        

        let bx =  mul(pow(t,2),  temp ) 
        let cx = pow(t,3)
        let x = add(bx,cx)

        let by =  mul( pow(t,2) ,  temp )  
        let cy = pow(t,3)
        let y =  add(by,cy)

        return [x,y]
      }
    },

    custom(t,p1,p2,type){ 
      type = type === true  /**为true就返回Css属性 */

      if(type){
        return "cubic-bezier(" + p1.x + "," + p1.y + "," + p.x + "," + p2.y + ")"

      }else{
        if(0< t && t > 1){
          console.error("t is too large")
          return 
        }

        let add = _this.math.add
        let mul = _this.math.mul
        let pow = _this.math.pow

        let temp = _this.math.sub(1,t) 

        let mx1 = mul(3,p1[0]) /**4个与3相乘的系数 */
        let mx2 = mul(3,p2[0])
        let my1 = mul(3,p1[1])
        let my2 = mul(3,p2[1])

        let ax = mul( mul(mx1,t),  pow(temp,2) )
        let bx =  mul( mul( mx2, pow(t,2) ),  temp )  
        let cx = pow(t,3)
        let x =  add( add(ax,bx),  cx )

        let ay = mul( mul(my1,t),  pow(temp,2) )
        let by =  mul( mul( my2, pow(t,2) ),  temp )  
        let cy = pow(t,3)
        let y =  add( add(ay,by),  cy )

        return [x,y]
      }

    }
  }

  slider.prototype.math ={ /**精度计算 */
    add(el,arg){      //加法   
      let r1,r2,m;   
      try{r1=el.toString().split(".")[1].length}catch(e){r1=0}   
      try{r2=arg.toString().split(".")[1].length}catch(e){r2=0}   
      m=Math.pow(10,Math.max(r1,r2))   
      return (el*m+arg*m)/m   
    },

    sub(el,arg){     //减法   
      return _this.math.add(el,-arg);   
    },

    mul(el,arg){      //乘法 
      let m=0,s1=el.toString(),s2=arg.toString();   
      try{m+=s1.split(".")[1].length}catch(e){}   
      try{m+=s2.split(".")[1].length}catch(e){}   
      return Number(s1.replace(".",""))*Number(s2.replace(".",""))/Math.pow(10,m)   
    },

    div(el,arg){     //除法   
      let t1=0,t2=0,r1,r2;   
      try{t1=el.toString().split(".")[1].length}catch(e){}   
      try{t2=arg.toString().split(".")[1].length}catch(e){}   
      with(Math){   
          r1=Number(el.toString().replace(".",""))   
          r2=Number(arg.toString().replace(".",""))   
          return (r1/r2)*pow(10,t2-t1);   
      }   
    },

    pow(el,arg){  //平方
      if(arg <= 1){
        return el

      }else{
        let res = el
        for(let i=1;i<arg;i++){
          res = _this.math.mul(res,el)
        }

        return res
      }
    }
  }

  window.Slider = slider   /**暴露到全局 */
})(window)



//////////////////
// WEBPACK FOOTER
// ./static/js/slider.js
// module id = EKy4
// module chunks = 142